<template>
  <UiPageTitle title="Логи" hide-arrow />
</template>

<script>
import UiPageTitle from '@/components/UiPageTitle.vue'

/** Page title of `Logs` page */
export default {
  components: {
    UiPageTitle,
  },
}
</script>
